import React from 'react';
import PropTypes from 'prop-types';
import cssclasses from './Comments.css';

const CommentsList = (props) => {

  return (
    <div className={cssclasses.comments}>
      {props.comments.map(comment => {
        return <div className={cssclasses.comment} key={`transaction-comment-${comment.BankDataCommentId}`}>
          <div className={cssclasses.content}>
            <h5 className={cssclasses.author}>{comment.Name}</h5>
            <div className={cssclasses.text}>
              {comment.Comment}
            </div>
            <div className={cssclasses.actions}>
            <button onClick={()=>props.handleDeleteComment(comment.BankDataCommentId)} className={`${cssclasses.list_action_button} ${cssclasses.delete}`}><i className="far fa-trash-alt"></i>Delete</button>
            </div>
          </div>
        </div>
      })}
    </div>

  )
}

CommentsList.propTypes = {
  comments: PropTypes.array.isRequired,
  handleDeleteComment: PropTypes.func.isRequired
};
export default CommentsList;


// WEBPACK FOOTER //
// ./src/components/Comments/CommentsList.js